import React from 'react';
import { IFormatterProps } from '../../../@types/workspaceTypes';
import { IBinLocation, IStockLot, PickType } from '../../../graphql/schema/p4types';
import { WarningPill } from '../../DropdownEditor/CustomOptions';

const isBinLocation = (rowData: IStockLot | IBinLocation): rowData is IBinLocation => {
  return (rowData as IBinLocation).__typename === 'BinLocation';
};

const BinLocationFormatter = (props: IFormatterProps<IStockLot | IBinLocation, String>) => {
  const rowData = props.dependentValues.rowData;
  const binLocation = isBinLocation(rowData) ? rowData : rowData.stock?.binLocation;
  const pickType = binLocation?.pickType;
  if (pickType !== PickType.Quarantine) {
    return props.value;
  }
  return (
    <>
      {props.value}
      <WarningPill style={{ float: 'right' }}>Quarantine</WarningPill>
    </>
  );
};

export default BinLocationFormatter;
